import React from 'react';
import PropTypes from 'prop-types';
import ListCheckbox from './list-checkbox';

const BrickListMenu = (props) => {
  const listMenu = props.showListMenu ? 'list-menu' : 'list-menu hidden';
  const brickOverlayClass = `brick-overlay ${listMenu}`;

  return (
    <div className={brickOverlayClass}>
      <div className="step step-header">
        <p className="gwi--add-to-list-title">Add to List <button className="return-sign" onClick={props.goBack}>
          <i className="fa fa-arrow-left" aria-hidden="true" />
        </button></p>
      </div>
      { props.brickData.userLists ?
        props.brickData.userLists.map(list =>
          <div className="step" key={list.id}>
            <ListCheckbox
              listId={list.id}
              checkboxName={list.name}
              list={list}
              brickData={props.brickData}
              updateUserLists={props.updateUserLists}
            />
          </div>) : null
      }
    </div>
  );
};

BrickListMenu.propTypes = {
  showListMenu: PropTypes.bool,
  goBack: PropTypes.func,
  /*eslint-disable */
  brickData: PropTypes.object,
  /*eslint-enable */
  updateUserLists: PropTypes.func.isRequired,
};

export default BrickListMenu;



// WEBPACK FOOTER //
// ./src/client/components/list/brick-list-menu.jsx